export default "__VITE_ASSET__diwMQK9J__"